// eslint-disable-next-line no-restricted-imports
import {
  CountryFragment,
  Query_LegalClientController_GetList_AllOf_1_List_Items_Representative_RoleInCompany_CivilLawSubject,
} from 'api/generated/graphql';
import { parseCountryEntity } from 'api/helpers/parseCountryEntity';
import {
  CivilLawSubjectType,
  LegalClientRepresentativeClientInfoEntity,
} from 'api/types/entity';
import { Maybe } from 'types/maybe';

interface LegalClientRepresentativeRepresentativeClientInfoApi {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  middleName?: Maybe<string>;
  phoneNumber?: Maybe<string>;
  residentialAddress?: Maybe<{
    country?: Maybe<CountryFragment>;
  }>;
  registrationAddress?: Maybe<{
    country?: Maybe<CountryFragment>;
  }>;
  roleInCompany?: Maybe<{
    civilLawSubject?: Query_LegalClientController_GetList_AllOf_1_List_Items_Representative_RoleInCompany_CivilLawSubject | null;
    authorityConfirmationDocument?: Maybe<{
      dateOfExpiration?: Maybe<string>;
    }>;
  }>;
  company?: Maybe<{
    fullName?: Maybe<string>;
  }>;
}

export const parseLegalClientRepresentativeClientInfoEntity = (
  representative: LegalClientRepresentativeRepresentativeClientInfoApi
): LegalClientRepresentativeClientInfoEntity => ({
  id: representative.id,
  email: representative.email,
  firstName: representative.firstName,
  lastName: representative.lastName,
  middleName: representative.middleName ?? undefined,
  phoneNumber: representative.phoneNumber ?? undefined,
  identityDocument: {
    expirationDate: representative.roleInCompany?.authorityConfirmationDocument
      ?.dateOfExpiration
      ? new Date(
          representative.roleInCompany.authorityConfirmationDocument.dateOfExpiration
        )
      : undefined,
  },
  residentialAddress: {
    country: representative?.residentialAddress?.country
      ? parseCountryEntity(representative?.residentialAddress?.country)
      : undefined,
  },
  registrationAddress: {
    country: representative?.registrationAddress?.country
      ? parseCountryEntity(representative?.registrationAddress?.country)
      : undefined,
  },
  roleInCompany: {
    civilLawSubject: representative?.roleInCompany?.civilLawSubject
      ? CivilLawSubjectType[representative?.roleInCompany?.civilLawSubject]
      : undefined,
  },
  company: {
    fullName: representative?.company?.fullName ?? undefined,
  },
});
